import axios from "axios"
import { API_BASE_URL } from "../config"

export const getManageLifeLogList = async (
  start_date: string,
  end_date: string,
  facility_id: string,
  medical_record_id: string
) => {
  try {
    const response = await axios.post(`${API_BASE_URL}/lifelog`, {
      session_code: localStorage.getItem("session_code"),
      start_date: start_date,
      end_date: end_date,
      facility_id: facility_id,
      medical_record_id: medical_record_id
    })

    if (response.status === 200) {
      return response.data
    } else if (response.status === 401) {
      throw new Error("session")
    } else {
      throw new Error("other")
    }
  } catch (error: any) {
    if (error.status === 401) {
      throw new Error("session")
    } else {
      throw error
    }
  }
}
